import { useEffect } from 'react';
import GuestLayout from '../../Layouts/GuestLayout';
import LoginBox from '../../Components/LoginBox';
import Checkbox from '../../Components/Checkbox';
import InputError from '../../Components/InputError';
import InputLabel from '../../Components/InputLabel';
import TextInput from '../../Components/TextInput';
import AuthButton from '../../Components/AuthButton';
import { Head, Link, useForm } from '@inertiajs/react';

export default function Login({ status, canResetPassword }) {
    const { data, setData, post, processing, errors, reset } = useForm({
        username: '',
        password: '',
        remember: false,
    });

    useEffect(() => {
        return () => {
            reset('password');
        };
    }, []);

    const submit = (e) => {
        e.preventDefault();
        post(route('signin'));
    };

    return (
        <GuestLayout>
            <Head title="Log in" />

            <LoginBox>
                <div className="w-full px-6 py-3 drop-shadow-md">

                    <div>
                        <div className="mt-4 text-left lg:mt-2">
                            <div className="inline-flex items-center w-full">
                                <h3 className="text-lg mx-auto font-medium text-slate-500 leading-6 lg:text-5xl uppercase">sign in</h3>
                            </div>
                            <div className="mt-4 text-base text-slate-500">
                                {status && <p className="mb-4 font-medium text-sm text-green-600">{status}</p>}
                            </div>
                        </div>
                    </div>

                    <form onSubmit={submit}>
                        <div className="mt-6 space-y-4">
                            <div>
                                <InputLabel className="sr-only" htmlFor="username" value="Username" />

                                <TextInput
                                    id="username"
                                    type="text"
                                    name="username"
                                    value={data.username}
                                    global={false}
                                    className="block w-full px-5 py-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                    placeholder="Enter your username"
                                    autoComplete="username"
                                    isFocused={true}
                                    onChange={(e) => setData('username', e.target.value)}
                                />

                                <InputError message={errors.username} className="mt-2" />

                            </div>

                            <div>
                                <InputLabel className="sr-only" htmlFor="password" value="Password" />

                                <TextInput
                                    id="password"
                                    type="password"
                                    name="password"
                                    value={data.password}
                                    global={false}
                                    className="block w-full px-5 py-3 text-base text-neutral-600 placeholder-slate-300 bg-slate-50 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-300"
                                    placeholder="Enter your password"
                                    autoComplete="current-password"
                                    onChange={(e) => setData('password', e.target.value)}
                                />

                                <InputError message={errors.password} className="mt-2" />
                            </div>

                            <div className="block my-4">
                                <label className="flex items-center">
                                    <Checkbox
                                        name="remember"
                                        className='border-slate-300 text-indigo-300 shadow-sm focus:ring-indigo-200'
                                        checked={data.remember}
                                        onChange={(e) => setData('remember', e.target.checked)}
                                    />
                                    <span className="ml-2 text-sm text-slate-600">Remember me</span>
                                </label>
                            </div>

                            <div className="flex flex-col mt-4 lg:space-y-4">
                                <AuthButton disabled={processing}>
                                    Sign in
                                </AuthButton>

                                {canResetPassword && (
                                    <span className="mx-auto">
                                        <Link
                                            href={route('password.forget')}
                                            className="underline text-sm inline-flex justify-center py-4 font-medium text-slate-500 focus:outline-none hover:text-neutral-600 focus:text-slate-600 sm:text-sm"
                                        >
                                            Forgot your password?
                                        </Link>
                                    </span>
                                )}
                            </div>
                        </div>
                    </form>

                </div>

            </LoginBox>

        </GuestLayout>
    );
}
